<span class="fas fa-circle outer-r-mini" [ngClass]="classification"></span>
<span class="vcenter">{{ word }}</span>
